import { useEffect, useRef, useState } from "react";
import PetInformation from "../PetInformation";
import VaccinationInfo from "../VaccinationInfo";

const Pethelthcertificate = () => {
  const [value, setValue] = useState(
    "This is to certify that, I have completed a physical health examination of the above-mentioned  pet animal at Vetic Pet Clinic. I certify that the animal is healthy at the time of examination. The pet animal does not show any evidence of disease or any infection at the time of my examination.The pet animal is duly dewormed from time to time.",
  );

  const textareaRef = useRef<HTMLTextAreaElement | null>(null);

  useEffect(() => {
    adjustHeight();
  }, [value]);

  const adjustHeight = () => {
    if (textareaRef.current) {
      textareaRef.current.style.height = "auto"; // Reset height
      textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`; // Adjust to content
    }
  };

  return (
    <div>
      <div>
        <PetInformation source="HELTH"/>
      </div>
      <div className="gap-2 flex mt-2 flex-col">
        <textarea
          ref={textareaRef}
          className="w-full border p-4 text-sm resize-none print:hidden"
          value={value} // Controlled component to retain content
          onChange={(e) => setValue(e.target.value)}
          onInput={adjustHeight}
          style={{
            overflowY: "auto",
            scrollbarWidth: "thin",
          }}
        />
        <div className="hidden print:block w-full print:border-none p-2 text-sm whitespace-pre-wrap">{value}</div>
      </div>
      <p className="py-3 font-bold">
        The Pet is fit to travel by train, airplane, bus or any other mode of transportation.
      </p>
      <div>
        <VaccinationInfo />
      </div>
      <p className="py-3 ">Veterinary Provider Information:</p>
      <div className="gap-2 flex  items-center w-full pt-3">
        <p className="text-xs w-[200px]">Doctor's Name</p>
        <input type="text" className="text-sm w-[400px]" />
      </div>
      <div className="gap-2 flex  items-center w-full mt-5">
        <p className="text-xs w-[200px]">Doctor's License Number:</p>
        <input type="text" className="text-sm w-[400px]" />
      </div>
      <div className="flex items-center justify-between pt-4">
        <p>Date</p>
        <p>Veterinarian's Signature</p>
      </div>
      <p className="pt-3 font-bold italic">This report is not valid for Vetero-Legal Purposes</p>
    </div>
  );
};

export default Pethelthcertificate;
